<script lang="ts" setup>
import { useI18n } from '@/plugins/i18n'
import SaiModal from '@/components/common/SaiModal/index.ce.vue';
import { ref } from 'vue';

const emit = defineEmits(['handleExportFieldSelection', 'handleExportFormatSelection', 'handleExportSearchResults', 'handleExportClose']);
//props
const props = defineProps({
    name: { type: String, default: '' , required: false },
    fieldOptions: { type: Array as () => {key: string, val: string}[], default: () => [] , required: false },
    status: { type: String, default: '' , required: false },
    selectedFormat: { type: String, default: 'csv' , required: false },
    totalFound: { type: Number, default: 0 , required: false },
    selectedFields: { type: Array as () => string[], default: () => [] , required: false },
    searchContext: { type: String, default: '' , required: false },
    note: { type: String, default: '' , required: false },
    maxExportLimit: { type: Number, default: 10000 , required: false },
});

//translations
const i18nInstance: any = useI18n()
const { t } = i18nInstance

//refs
const display = ref(false);

// emits
const closeModal = () => {
    display.value = false;
    emit('handleExportClose')
}
 
const showExportSearchModal = () => {
    display.value = true;
}

</script>

<template>
    <div :class="['btn-export']" @click="showExportSearchModal">{{ t('export') }}</div>
    <SaiModal :display="display" @closeModal="closeModal" className="export-search-modal" :processing="status == 'inprogress'">
        <template #title>
            <div class="title-wrapper">
                <div class="main-title">
                    <template v-if="status == 'completewitherror' || status == 'completewitherror'">{{ t('export') }}</template>
                    <template v-else>{{ t('exportOptions') }}</template>
                </div>
            </div>
        </template>
        <template #body>
           <div class="export-search-body" v-if="status == '' || status == 'inprogress'">
                <div class="export-type">
                    <div class="export-type-label">{{ t('type') }}</div>
                    <div class="export-type-options">
                        <div :class="['export-type-option', selectedFormat == 'csv' ? 'selected' : '']" @click="emit('handleExportFormatSelection', 'csv')">{{ t('comma') }}</div>
                        <div :class="['export-type-option', selectedFormat == 'tsv' ? 'selected' : '']" @click="emit('handleExportFormatSelection', 'tsv')">{{ t('tab') }}</div>
                    </div>
                </div>
                <div class="export-fields">
                    <div class="export-fields-label">{{ t('options') }}</div>
                    <div class="export-fields-options">
                        <div v-for="(field, index) in fieldOptions" :key="index" :class="['export-fields-option', selectedFields.includes(field.key) ? 'selected' : '']" @click="emit('handleExportFieldSelection', field.key)">
                            {{ t(field.val.toLowerCase()) }}
                        </div>
                    </div>
                </div>
                <div class="export-note"><b>{{ t('note') }}</b>: {{ note }}</div>
                <div class="button-group">
                    <button class="btn-cancel" @click="closeModal">{{ t('cancel') }}</button>
                    <button class="btn-save" @click="$emit('handleExportSearchResults')">{{ t('export') }}</button>
                </div>
           </div>
            <span v-if="status == 'complete'">
                {{ t('exportJobCreated') }}
            </span>
            <span v-if="status == 'complete' && totalFound > maxExportLimit">
                <br><br>
                {{ t('exportTotalFound', [totalFound, maxExportLimit]) }}
            </span>
            <span v-if="status == 'completewitherror'">Some error occurred while setting up export job...</span>
            <div style="display:none;"> <!-- hide the form, submition will triggered via export action-->
                <form :id="`${name}-export-form`" method="post" target="_blank" :action="`/management/search/updates`">
                    <input type="hidden" name="exportSearch" value="1">
                    <input type="radio" id="file[csv]" name="file[]" value="csv" :checked="selectedFormat == 'csv'"/>
                    <input type="radio" id="file[tsv]" name="file[]" value="tsv" :checked="selectedFormat == 'tsv'"/>
                    <input v-for="(field, index) in fieldOptions"  type="checkbox" name="exportFields[]" :value="field.key" :checked="selectedFields.includes(field.key)" :key="index"/>
                </form>
            </div>
        </template>
    </SaiModal>
</template>